import React, { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import AssetManager from "../AssetManager";
import CustomModal from "./CustomModal";

const KartonModal: React.FC<KartonModalProps> = ({
  open,
  setOpen,
  children,
  kartonImageUrl,
  clothName,
}) => {
  const { i18n } = useTranslation();

  function getCustomModalContent() {
    return (
      <>
        <div className="karton-modal-header">
          <div className="karton-details">
            <p className="karton-modal-title">{clothName}</p>
            <p className="karton-modal-description">
              {i18n.t("karton_modal_description", { clothName: clothName })}
            </p>
          </div>

          <div
            className="karton-modal-close"
            onClick={() => {
              setOpen(false);
            }}
          >
            <img
              src={AssetManager.getAsset("/close_icon.svg")}
              alt="close-icon"
            />
          </div>
        </div>
        <div className="karton-image-container">
          <img src={kartonImageUrl} alt="karton info" />
          {children}
        </div>
      </>
    );
  }

  return (
    <>
      <CustomModal open={open} setOpen={setOpen} containerClassName={""}>
        {getCustomModalContent()}
      </CustomModal>
    </>
  );
};

export default KartonModal;

export interface KartonModalProps {
  open: boolean;
  setOpen: (o: boolean) => void;
  children?: ReactElement;
  kartonImageUrl: string;
  clothName: string;
}
